import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { ReviewCard } from "../ReviewCard/ReviewCard";
export const PlatformsReviewSwiper = ({ reviews }) => (React.createElement(Swiper, { breakpoints: {
        375: {
            slidesPerView: 1.2,
            spaceBetween: 12,
        },
        601: {
            slidesPerView: 1.55,
            spaceBetween: 16,
        },
        1025: {
            slidesPerView: reviews.length
        },
    } }, Array.isArray(reviews) && reviews.map((review) => (React.createElement(SwiperSlide, { key: `review-slide-${review.authorName}` },
    React.createElement(ReviewCard, { ...review }))))));
